import { render, staticRenderFns } from "./informationCategory.vue?vue&type=template&id=6ac56690&scoped=true"
import script from "./informationCategory.vue?vue&type=script&lang=js"
export * from "./informationCategory.vue?vue&type=script&lang=js"
import style0 from "./informationCategory.vue?vue&type=style&index=0&id=6ac56690&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac56690",
  null
  
)

export default component.exports